export const KTechPioneersImgUrl =
  'https://d35ai18pny966l.cloudfront.net/course/events/ktechpioneers'

export const statusOptions = [
  { label: 'Closed', value: 'closed' },
  { label: 'Ongoing', value: 'ongoing' },
]

export const industryOptions = [
  { label: '반도체·디스플레이', value: 'semiconductor_display', color: '#29B6F6' },
  { label: '이차전지', value: 'rechargeable_battery', color: '#00C853' },
  { label: '첨단 모빌리티', value: 'advanced_mobility', color: '#FF6D00' },
  { label: '차세대 원자력', value: 'advanced_nuclear', color: '#00BFA5' },
  { label: '첨단 바이오', value: 'advanced_bio', color: '#F50057' },
  { label: '우주항공·해양', value: 'space_and_ocean', color: '#AA00FF' },
  { label: '수소', value: 'hydrogen', color: '#00E5FF' },
  { label: '사이버보안', value: 'cybersecurity', color: '#D50000' },
  { label: '인공지능', value: 'artificial_intelligence', color: '#3D5AFE' },
  { label: '차세대 통신', value: 'next_gen_telecom', color: '#C6FF00' },
  { label: '첨단로봇·제조', value: 'advanced_robotics_manufacturing', color: '#78909C' },
  { label: '양자', value: 'quantum', color: '#FF4081' },
]

export const KTechPioneersList = [
  {
    url: 'https://ktechpioneers.com/03',
    thumbnail: `${KTechPioneersImgUrl}/list_hyundai.png`,
    type: [
      'artificial_intelligence',
      'advanced_mobility',
      'advanced_robotics_manufacturing',
      'space_and_ocean',
    ],
    company: '현대자동차그룹',
    title: 'SDV, 로보틱스, 우주항공 분야의 모빌리티 혁신을 만들어가는 기업',
  },
  {
    url: 'https://ktechpioneers.com/01',
    thumbnail: `${KTechPioneersImgUrl}/list_sk.png`,
    type: ['artificial_intelligence', 'semiconductor_display'],
    company: 'SK이노베이션',
    title: '정유와 화학 산업 기반으로 LNG, 전력, 신재생에너지로 이어지는 글로벌 에너지 혁신 기업',
  },
  {
    url: 'https://ktechpioneers.com/04',
    thumbnail: `${KTechPioneersImgUrl}/list_lsp.png`,
    type: [
      'artificial_intelligence',
      'semiconductor_display',
      'rechargeable_battery',
      'advanced_robotics_manufacturing',
    ],
    company: 'LG사이언스파크',
    title:
      'AI, 바이오, 클린테크 등 미래 핵심 기술 분야의 융합 연구와 협업을 통해 LG차세대 혁신을 이끄는 대표 연구개발 허브',
  },
  {
    url: 'https://ktechpioneers.com/05',
    thumbnail: `${KTechPioneersImgUrl}/list_kamo.png`,
    type: ['artificial_intelligence', 'advanced_mobility'],
    company: '카카오모빌리티',
    title: '모든 이동의 가치를 실현하는 대한민국 대표 모빌리티 기업',
  },
  {
    url: 'https://ktechpioneers.com/22',
    thumbnail: `${KTechPioneersImgUrl}/list_kt.png`,
    type: ['artificial_intelligence'],
    company: 'KT',
    title: '대한민국 연결의 현재와 미래를 책임지며 AX 시대를 선도하는 플랫폼과 혁신 기업',
  },
  {
    url: 'https://ktechpioneers.com/07',
    thumbnail: `${KTechPioneersImgUrl}/list_db.png`,
    type: ['artificial_intelligence'],
    company: 'DB손해보험',
    title: '상품, 마케팅, 고객관리 등 보험 밸류체인 선도 종합손해보험회사',
  },
  {
    url: 'https://ktechpioneers.com/12',
    thumbnail: `${KTechPioneersImgUrl}/list_toss.png`,
    type: ['artificial_intelligence', 'cybersecurity'],
    company: '토스',
    title: '누구나 쉽고 편리한 금융 서비스를 누릴 수 있게 하는 핀테크 플랫폼',
  },
  {
    url: 'https://ktechpioneers.com/14',
    thumbnail: `${KTechPioneersImgUrl}/list_upstage.png`,
    type: ['artificial_intelligence'],
    company: '업스테이지',
    title: '생성형 AI와 LLM 기술로 업무 생산성 및 산업별 AI 전환을 가속화하는 기업',
  },
  {
    url: 'https://ktechpioneers.com/06',
    thumbnail: `${KTechPioneersImgUrl}/list_amore.png`,
    type: ['artificial_intelligence', 'advanced_bio'],
    company: '아모레퍼시픽',
    title: '뷰티·헬스·웰니스 분야의 혁신으로 글로벌 고객 경험을 확장하는 기업',
  },
  {
    url: 'https://ktechpioneers.com/15',
    thumbnail: `${KTechPioneersImgUrl}/list_lig.png`,
    type: ['artificial_intelligence', 'advanced_mobility', 'next_gen_telecom'],
    company: 'LIG Accuver',
    title: '국내 최초로 무선망 최적화 장비를 국산화한 통신 계측 및 측정 장비 전문 기업',
  },
  {
    url: 'https://ktechpioneers.com/11',
    thumbnail: `${KTechPioneersImgUrl}/list_hl.png`,
    type: ['artificial_intelligence', 'advanced_mobility', 'advanced_robotics_manufacturing'],
    company: 'HL로보틱스',
    title: '피지컬AI로 공간의 한계를 넘어 사람과 로봇이 공존하는 새로운 일상을 만드는 기업',
  },
  {
    url: 'https://ktechpioneers.com/10',
    thumbnail: `${KTechPioneersImgUrl}/list_hoban.png`,
    type: ['artificial_intelligence', 'next_gen_telecom', 'advanced_robotics_manufacturing'],
    company: '호반그룹',
    title: '건설·주택·유통·레저 등 다양한 산업에서 미래 가치를 창출하는 종합개발 그룹',
  },
  {
    url: 'https://ktechpioneers.com/09',
    thumbnail: `${KTechPioneersImgUrl}/list_puluone.png`,
    type: ['artificial_intelligence'],
    company: '풀무원',
    title: '사람과 지구의 건강한 내일을 위해 바른 먹거리를 제공하는 기업',
  },
  {
    url: 'https://ktechpioneers.com/16',
    thumbnail: `${KTechPioneersImgUrl}/list_ahnlab.png`,
    type: [
      'cybersecurity',
      'artificial_intelligence',
      'advanced_robotics_manufacturing',
      'quantum',
    ],
    company: '안랩',
    title: 'V3에서 AI 보안까지, 30년 혁신을 이어온 사이버보안 기업',
  },
  {
    url: 'https://ktechpioneers.com/21',
    thumbnail: `${KTechPioneersImgUrl}/list_hanabank.png`,
    type: ['artificial_intelligence', 'cybersecurity'],
    company: '하나은행',
    title: '함께 성장하며 행복을 나누는 금융, 하나은행이 유망 스타트업의 빛나는 내일을 함께합니다.',
  },
  {
    url: 'https://ktechpioneers.com/19',
    thumbnail: `${KTechPioneersImgUrl}/list_shinhan.png`,
    type: [
      'semiconductor_display',
      'advanced_mobility',
      'cybersecurity',
      'artificial_intelligence',
    ],
    company: '신한벤처투자',
    title: '고객의 내일을 위해 우리의 오늘을 투자하는, 신한벤처투자',
  },
  {
    url: 'https://ktechpioneers.com/17',
    thumbnail: `${KTechPioneersImgUrl}/list_wrtn.png`,
    type: ['artificial_intelligence'],
    company: '뤼튼테크놀로지스',
    title: '누구나 제약 없이 일상에서 쉽고 간편하게 AGI를 활용할 수 있게 돕는 AI 플랫폼',
  },
  {
    url: 'https://ktechpioneers.com/13',
    thumbnail: `${KTechPioneersImgUrl}/list_cau.png`,
    type: ['artificial_intelligence', 'advanced_bio', 'advanced_robotics_manufacturing'],
    company: '중앙대학교광명병원',
    title: '첨단 의료기술과 연구 역량을 바탕으로 미래 헬스케어를 선도하는 병원',
  },
  {
    url: 'https://ktechpioneers.com/18',
    thumbnail: `${KTechPioneersImgUrl}/list_srb.png`,
    type: ['artificial_intelligence', 'advanced_mobility'],
    company: '서라벌도시가스',
    title: '청정연료 도시가스(LNG)를 공급하여 자연에 대한 약속을 지키는 기업',
  },
  {
    url: 'https://ktechpioneers.com/astnova',
    thumbnail: `${KTechPioneersImgUrl}/list_astnova.png`,
    type: [
      'artificial_intelligence',
      'semiconductor_display',
      'next_gen_telecom',
      'advanced_mobility',
    ],
    company: '아스트노바',
    title: '실시간 이머시브 변환, 객체-사운드 맵핑 기술 등을 보유한 AI 솔루션 기업',
  },
  {
    url: 'https://ktechpioneers.com/20',
    thumbnail: `${KTechPioneersImgUrl}/list_wit.png`,
    type: ['artificial_intelligence', 'semiconductor_display', 'cybersecurity'],
    company: '위트글로벌',
    title: 'AI와 AR 기술로 K-관광(K-컬처)의 새로운 오프라인 경험을 창조하는 O2O 플랫폼 기업',
  },
]

// 지원 대상 모달 팝업 내용
export type TargetLine = {
  text: string
  level?: 0 | 1 | 2
  tone?: 'default' | 'note' | 'header'
}

export type IntroSegment = {
  text: string
  underline?: boolean
  sup?: string
}

export type TargetSection = {
  title: string
  intro?: string | IntroSegment[]
  lines?: TargetLine[]
}

export const targetDetails: TargetSection[] = [
  {
    title: '신청 자격',
    intro: [
      { text: 'AI·AX 등 초격차 기술 분야의 ' },
      { text: '우수 고급 기술을 보유', underline: true, sup: '1' },
      { text: '한 ' },
      { text: '재외 한국인(국적자)', underline: true, sup: '2' },
      { text: ' 중심의 ' },
      { text: '(예비) 창업자·팀(법인)', underline: true, sup: '3' },
    ],
  },
  {
    title: '1. 우수 고급 기술 인력 요건',
    lines: [
      {
        text: '해외에서 기술 기반의 연구, 산업, 창업 등과 관련된 전문성과 활동 이력을 보유한 자로서, 아래 요건 중 1개 이상에 해당하는 자',
      },
      {
        level: 1,
        text: '연구 분야 : 논문, 특허, 기술문서, 저널 등에서 주저자 또는 핵심 기여자로 활동한 자',
      },
      {
        level: 1,
        text: '산업 분야 : 글로벌 기술기업(빅테크 등)에서 기술 관련 경력을 보유한 자',
      },
      {
        level: 1,
        text: '창업 분야 : 해외 기술 기반 창업 또는 기술사업화 이력을 보유한 자',
      },
      { tone: 'header', text: '필수 제출서류' },
      {
        level: 1,
        text: '연구 분야(논문·특허·기술문서 등): 논문, 기술문서, 저널 등 주저자 활동/인용 입증 가능 서류',
      },
      {
        level: 1,
        text: '산업 분야(글로벌 기술기업 재직자 등): 글로벌 기술기업 재직·경력증명서, 추천서 등 관련 경력을 입증할 수 있는 서류',
      },
      {
        level: 1,
        text: '창업 분야(창업자): 해외 법인등록증(Certificate of Incorporation) 등 법인 고유식별번호가 기재된 정부 발급 서류 일체 및 사업 성과를 입증할 수 있는 서류',
      },
      { level: 1, text: '기타: 기술 우수성을 입증할 수 있는 관련 서류' },
    ],
  },
  {
    title: '2. 재외 한국인·한국 국적자 요건',
    lines: [
      {
        text: '재외 한국인 : 거주 관할권의 공인 정부기관이 발급한 거주증명서 및 재외 한국인 증명서를 제출할 수 있는 자',
      },
      {
        level: 1,
        tone: 'note',
        text: '최종 선정 시, 2026년 1월 1일 이후 정부24에서 발급한 출입국사실증명서 제출 필수',
      },
      { text: '국적자 : 공고일 기준 대한민국 국적을 보유한 자' },
      {
        level: 1,
        tone: 'note',
        text: '정부24 발급 국적 관련 사실증명서 제출 필수',
      },
    ],
  },
  {
    title: '3. 팀 구성 요건',
    lines: [
      {
        text: '필수 요건 : 우수 기술을 보유한 재외 한국인 또는 한국 국적자가 대표자, 창업자, 공동창업자 또는 주요 인력으로 참여한 팀(1인 이상)',
      },
      {
        level: 1,
        tone: 'note',
        text: '"주요 인력"의 기준 : 참가팀의 경영 또는 기술 분야에서 핵심적인 역할을 수행하는 자로서, 아래 요건 중 1개 이상에 해당하는 자',
      },
      {
        level: 2,
        text: '해당 팀(법인)이 출원·등록한 특허(IP) 등 핵심 기술에 발명자 또는 권리자로 등재된 자',
      },
      {
        level: 2,
        text: '직무 기여도가 높아 해당 팀의 대표자가 핵심 인력으로 지정한 자',
      },
      { text: '지분 요건 : 공고일 기준, 아래 요건 중 1개 이상을 충족하는 팀' },
      { level: 1, text: '재외 한국인 또는 한국 국적자가 50% 이상으로 구성된 팀' },
      {
        level: 1,
        text: '재외 한국인 또는 한국 국적자가 지분 15% 이상을 보유한 벤처·창업기업',
      },
    ],
  },
  {
    title: '※ 공통 지원 자격',
    lines: [
      { text: '국내 입국 및 해외여행에 결격사유가 없는 자' },
      { text: '국가연구개발사업 등 정부지원사업 참여에 제한이 없는 자' },
      { text: '국내 법인 설립 및 국내외 활동 수행에 결격사유가 없는 자' },
      {
        text: '국내외 활동과 관련하여 사회적 물의 또는 중대한 법적·윤리적 문제가 없는 자',
      },
      { tone: 'header', text: '세부 결격사유' },
      { level: 1, text: '「국가공무원법」 제33조 각 호에 해당하는 자' },
      {
        level: 1,
        text: '「아동·청소년의 성보호에 관한 법률」 제56조에 따라 취업제한 명령을 받은 자',
      },
      {
        level: 1,
        text: '「부패방지 및 국민권익위원회의 설치와 운영에 관한 법률」 제82조에 따라 취업제한 중인 자',
      },
      {
        level: 1,
        text: '병역면제자(병역특례 대상자 포함)를 제외하고 병역을 필하지 않았거나, 「병역법」 제76조에 따른 병역의무 불이행자',
      },
      {
        level: 1,
        text: '다른 공공기관에서 부정한 방법으로 채용된 사실이 적발되어 채용이 취소 또는 면직된 자로서, 그 취소 또는 면직일로부터 5년이 경과하지 않은 자',
      },
      {
        level: 1,
        text: '「출입국관리법」 제11조 제1항에 따라 입국이 금지된 자',
      },
      {
        level: 1,
        text: '채무불이행, 산업재해, 불공정행위, 임금체불 등 국내외 활동 수행에 중대한 문제가 있다고 판단되는 이력이 있는 자',
      },
      { tone: 'header', text: '기타 참고 사항' },
      {
        level: 1,
        text: '원천기술 등을 활용하는 경우, 해당 지식재산권의 주저자 또는 이에 준하는 권리자의 사업 참여 필수',
      },
      { level: 1, text: '최종 선정 후, 국내에서의 법인 설립 및 납세자 등록 필수' },
    ],
  },
]

// 모집 분야 모달 팝업 내용
export const industryDetails = [
  {
    title: '반도체·디스플레이',
    desc: '차세대반도체 소자·공정, 첨단 패키징, 그리드·차세대 디스플레이 기술',
  },
  {
    title: '이차전지',
    desc: '차세대 배터리 소재·전극, 배터리 관리시스템(BMS), 장시간 재활용 기술',
  },
  {
    title: '첨단 모빌리티',
    desc: '전기·자율주행차기, 도심항공교통(UAM), 친환경 SW·H/W 및 이차 운송 시스템 기술',
  },
  {
    title: '차세대 원자력',
    desc: '수형탈출전환(SMR), 원전 안전성·운용 효율화, 사용후핵연료 및 원전 해체 기술',
  },
  {
    title: '첨단 바이오',
    desc: '디지털헬스, 신약개발, 인진·세포치료, 현대생체 및 바이오 제조 기술',
  },
  {
    title: '우주항공·해양',
    desc: '저궤도 위성통신 모뎀·단말, 해양자원 클로링, 자원탐원 및 개발관련 기술',
  },
  { title: '수소', desc: '수소 생산·저장·운송·활용 전주기 기술 및 연료전지 기반 발전·시스템' },
  {
    title: '사이버보안',
    desc: '네트워크·클라우드·산업시스템 보안, 개인정보 보호, 취약 탐지·대응 기술',
  },
  {
    title: '인공지능',
    desc: '생성형 AI, 데이터AI, 현실데이터, 판단인공지능 및 AI활용 서비스 기술',
  },
  {
    title: '차세대 통신',
    desc: '6G통신, 차세대 무선통신·네트워크 고도화, 온센물 차이전 통신 전자서 기술',
  },
  {
    title: '첨단로봇·제조',
    desc: '지능형 로봇, 스마트제조시스, 디지털화, 자동화·정밀제어 및 신재빙합 기술',
  },
  { title: '양자', desc: '양자컴퓨팅, 양자통신, 양자센서 및 양자 소재·부품 응용 기술' },
]

export const recruitInfoItems = [
  {
    icon: `${KTechPioneersImgUrl}/icon_calendar.png`,
    title: '신청 기간',
    desc: '2026.04.08 ~ 2026.04.28.',
  },
  {
    icon: `${KTechPioneersImgUrl}/icon_who.png`,
    title: '지원 대상',
    desc: '글로벌 활동 중인 한국 국적 과학기술 인재팀',
    modalType: 'target' as const,
  },
  {
    icon: `${KTechPioneersImgUrl}/icon_techtype.png`,
    title: '기술 분야',
    desc: '과학기술정보통신부 선정 12대 국가전략기술',
    modalType: 'tech' as const,
  },
]

export const partnerDetails = [
  {
    label: '총괄 부처',
    list: [
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_main.png`,
        name: '과학기술정보통신부',
      },
    ],
  },
  {
    label: '전담 기관',
    list: [
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_nipa.png`,
        name: 'nipa 정보통신산업진흥원',
      },
    ],
  },
  {
    label: '운영 기관',
    list: [
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_logo_likelion.png`,
        name: '멋쟁이사자처럼',
      },
    ],
  },
  {
    label: '참여 기관',
    list: [
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_sparklabs.png`,
        name: 'SparkLabs',
      },
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_mission.png`,
        name: 'MISSION',
      },
      {
        imgUrl: `${KTechPioneersImgUrl}/partner_wave.png`,
        name: '특허법인 더웨이브',
      },
    ],
  },
]

export const growthCards = [
  {
    imgUrl: `${KTechPioneersImgUrl}/growth_icon_1.png`,
    title: '한국 시장 진입',
    desc: '국내 프론티어 기관과의 연계를 통해 한국 시장 진출 기회 제공',
  },
  {
    imgUrl: `${KTechPioneersImgUrl}/growth_icon_2.png`,
    title: '맞춤형 오픈이노베이션',
    desc: '기술 분야와 성장 단계에 맞춘 파트너 매칭 및 협력 과제 기획',
  },
  {
    imgUrl: `${KTechPioneersImgUrl}/growth_icon_3.png`,
    title: '정부 지원 기반 확장성',
    desc: '정부의 지원으로 안정적인 국내 협력 환경 속에서 사업 확장의 기반을 마련',
  },
]

export const collaborationTracks = [
  {
    label: '오픈이노베이션 트랙',
    items: [
      { title: '공동 R&D', desc: '과제 통합을 위한 로드맵 개발' },
      { title: 'PoC 실증', desc: '적용성 확인을 위한 단기 현장 검증' },
      { title: 'IP/기술 이전', desc: '성숙 기술의 라이센싱 및 내재화' },
    ],
  },
  {
    label: '창업/벤처 트랙',
    items: [
      { title: '합작법인(JV)', desc: 'JV/스핀오프 또는 국내 법인 전환 모델 설계' },
      { title: '지분 투자', desc: 'CVC 및 외부 VC를 통한 SI/FI 검토 및 집행' },
      { title: '사업 연계', desc: '인큐베이팅 및 액셀러레이션 프로그램 연계' },
    ],
  },
  {
    label: '채용 트랙',
    items: [
      { title: '핵심 인재 채용', desc: '글로벌 인재 정규/계약직 직접 채용' },
      { title: '계열사 연계', desc: '그룹 계열사 또는 투자 기업 채용 연계' },
      { title: '인재 스카우팅', desc: '기업의 요구에 맞춘 전용 스카우팅 지원' },
    ],
  },
]

export const benefitDetails = [
  {
    count: 'BENEFIT 01',
    title: '사업화지원금',
    descList: [
      '협력과제 수행을 위한 사업화·R&D 비용 지원 \n(참가팀별 2억 원 내외, 기관부담비(현금/현물)25%)',
    ],
  },
  {
    count: 'BENEFIT 02',
    title: '인프라 지원',
    descList: ['서울·수도권 등 주요 거점 공유오피스 제공', 'AI툴 · SW 크레딧 지원'],
  },
  {
    count: 'BENEFIT 03',
    title: '정착 지원',
    descList: ['참가팀 국내 체류비 지원 \n(1인당 월 200만원 지원, 팀별 최대 2인 지원)'],
  },
  {
    count: 'BENEFIT 04',
    title: '컨시어지 지원',
    descList: ['1:1 전담 매니저 밀착 지원', '비자, 법인설립, 생활 정착 등 전 과정 밀착 케어'],
  },
  {
    count: 'BENEFIT 05',
    title: '법무 & 특허 지원',
    descList: [
      '법률 · 계약 · 노무 등 법률 자문 컨설팅 제공',
      'IP·전략·권리화 등 특허 자문 컨설팅 제공',
    ],
  },
  {
    count: 'BENEFIT 06',
    title: '전문가 연계 지원',
    descList: [
      '국내 대·중견기업과 1:1 비즈니스 매칭 지원',
      '국내외 유수 투자사 IR 및 투자 연계 제공',
    ],
  },
]

export const reviewSchedule = [
  {
    step: '1 단계',
    title: '적격성 심사',
    imgUrl: `${KTechPioneersImgUrl}/review_img1.png`,
    typeList: ['# 전체 지원팀', '# 서류 기반 검토'],
    desc: '지원 자격과 제출 서류 등 적합성 심사',
    descList: ['지원 자격 및 필수 요건 확인', '팀 구성 및 참여 조건 검토'],
    summary: '적격 팀에 한해 다음 단계 진출',
  },
  {
    step: '2 단계',
    title: '서류 심사',
    imgUrl: `${KTechPioneersImgUrl}/review_img2.png`,
    typeList: ['# 최대 100개 팀 선발', '# 서면 평가'],
    desc: '기술성 · 사업성 · 성장 가능성 등 서류 평가',
    descList: ['팀 역량 및 기술력 중심 서면 평가', '기술력 및 비즈니스 모델 경쟁력 등 평가'],
    summary: '상위 100개 팀 대면 심사 진출 (예정)',
  },
  {
    step: '3 단계',
    title: '대면 심사',
    imgUrl: `${KTechPioneersImgUrl}/review_img3.png`,
    typeList: ['# 20개 팀 최종 선발', '# 오프라인 현지 평가'],
    desc: '대면 피칭 기반 최종 선발 평가',
    descList: ['대면 발표 및 질의응답 진행', '기술의 구체성, 국내 정착 가능성 등 평가'],
    summary: '평가 권역 : 샌프란시스코 / 뉴욕 / 싱가포르',
  },
]

export const processSteps = [
  {
    step: 1,
    title: '1. 사업 지원',
    desc: '기술력과 한국 시장 진출 가능성을 바탕으로 \n프로그램에 지원하고 협력 가능성을 확인합니다.',
    side: 'right' as const,
  },
  {
    step: 2,
    title: '2. 선정 평가 및 매칭',
    desc: '기술 적합성, 사업성, 협력 가능성을 종합적으로 검토하고 \n국내 기업 및 기관과의 매칭을 추진합니다.',
    side: 'left' as const,
  },
  {
    step: 3,
    title: '3. 실증 및 사업화 추진',
    desc: '매칭된 파트너와 함께 PoC, 공동 프로젝트, \n기술 검증 등 구체적인 협력을 수행합니다.',
    side: 'right' as const,
  },
  {
    step: 4,
    title: '4. 데모데이 참여 및 후속 지원',
    desc: '성과 검토를 바탕으로 투자 연계, \n추가 사업화, 장기 파트너십 확대를 지원합니다.',
    side: 'left' as const,
  },
]

export const pioneersFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '기본 사항',
    value: 'default',
  },
  {
    label: '지원 내용',
    value: 'support',
  },
  {
    label: '사업비 편성 및 관리',
    value: 'management',
  },
  {
    label: '선정 절차',
    value: 'selection',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

export const pioneersFaqDetailList = {
  default: [
    {
      question: '1-1. 우수 고급 재외 한국인의 최소 기준은 무엇인가요?',
      answer:
        '해외에 거주 중인 한국 국적자로서, AI·AX 등 초격차 기술 분야의 우수한 고급 기술을 보유하고 있음을 서류로 입증할 수 있어야 합니다.',
    },
    {
      question: '1-2. 한국 국적은 없지만 한국계입니다. 지원 가능한가요?',
      answer:
        '한국 국적이 없는 한국계 인력도 팀원으로는 참여할 수 있습니다. \n다만 본 사업은 우수한 기술을 보유한 재외 한국인이 주요 인력으로 1인 이상 포함된 팀이어야 하며, 해당 인력이 팀 리더이면서 국내 법인 설립이 예정되어 있거나 가능해야 합니다.',
    },
    {
      question: '1-3. 이미 한국에 거주 중인 한국인도 지원할 수 있나요?',
      answer:
        '팀원으로는 참여할 수 있습니다. 다만, 팀 리더 및 팀 구성과 관련한 사업의 기본 요건은 충족해야 합니다.',
    },
    {
      question: '1-4. 1인으로 구성된 팀도 지원 가능한가요?',
      answer: '네, 가능합니다.',
    },
    {
      question: '1-5. 한국 국적이 아닌 팀원을 포함할 수 있나요?',
      answer:
        '네, 가능합니다. 다만, 팀 리더 및 팀 구성과 관련한 사업의 기본 요건은 충족해야 합니다.',
    },
    {
      question: '1-6. 해외법인은 있으나 한국 법인은 없습니다. 신청에 제약이 있나요?',
      answer:
        '법인 자체가 아니라, 지분 구조를 고려한 해외법인 관련 팀으로 지원하는 경우 신청이 가능합니다.\n단, 한국 내 법인 설립 등기 이력이 없어야 하며, 과거 타 정부 지원사업 수행 이력도 없어야 합니다.',
    },
    {
      question: '1-7. 해외법인이면서 국내 지점 또는 연락사무소가 있습니다. 신청에 제약이 있나요?',
      answer:
        '해외법인이 있더라도 국내 지점 또는 연락사무소만 있는 경우에는 법인 설립 등기를 완료한 것으로 보지 않으므로, 관련 팀 형태로는 신청이 가능합니다. \n또한 최종 선정 시에는 국내 법인 설립 및 지분율 등 관련 요건을 반드시 충족해야 합니다.',
    },
  ],
  support: [
    {
      question: '2-1. 기존 수요처가 제출한 오픈이노베이션 과제에 지원하려면 어떻게 해야 하나요?',
      answer:
        '‘협력 과제’ 페이지에서 지원을 희망하는 과제를 선택한 뒤, 사업계획서 및 제출서류를 함께 접수하여 지원하시면 됩니다.\n최대 2개의 오픈이노베이션 과제까지 선택하여 제출할 수 있으며, 해당 내용은 사업계획서에 2페이지 이내로 작성해 주시면 됩니다.\n사업비 편성은 최종 선정 이후 확정 절차에 따라 별도로 제출 요청드릴 예정이며, 신청 단계에서는 정부출연금 대비 부담금 비율만 작성하여 제출하시면 됩니다.',
    },
    {
      question: '2-2. 오픈이노베이션이 아닌 자유 주제로도 지원할 수 있나요?',
      answer:
        '네, 가능합니다. 협업 프로젝트 리스트 내 과제를 선택하지 않고 자유 주제로 신청하는 경우에도 사업계획서를 제출하실 수 있습니다. \n이 경우 신청서 내 ‘참가내용’ 항목은 작성하지 않으셔도 됩니다.',
    },
    {
      question: '2-3. 반드시 수요처 매칭이 이루어져야 하나요?',
      answer:
        '네, 최종적으로는 수요처 매칭이 반드시 이루어져야 합니다. \n다만, 신청 단계에서 오픈이노베이션 트랙 또는 자유 주제를 선택하더라도 수요처 매칭이 즉시 확정되는 것은 아닙니다. \n최종 선정된 20개 팀을 대상으로, 제출한 오픈이노베이션 과제와 수요처 매칭 희망 순위 등을 종합적으로 고려하여 우선 매칭을 진행할 예정입니다. \n또한 운영기관이 추가로 발굴하는 수요처를 통해서도 지속적으로 매칭을 추진할 예정입니다. \n그럼에도 불구하고 합리적인 대내외 사유로 인해 매칭이 성사되지 않는 경우에는, 사업화 추진 노력도 등을 종합적으로 고려하여 최종 평가에 반영할 예정입니다.',
    },
    {
      question: '2-4. 오픈이노베이션 방식과 자율 방식 모두로 지원 가능한가요?',
      answer: '네, 두 방식 모두 지원 가능합니다.',
    },
    {
      question: '2-5. 오픈이노베이션 방식으로 지원하는 것이 선정에 더 유리한가요?',
      answer:
        '아닙니다. 오픈이노베이션 방식과 자율 방식 간 별도의 선정 비율은 정해져 있지 않습니다.',
    },
    {
      question:
        '2-6. 특정 국내 대기업 또는 기관과 이미 협력 논의 중입니다. 해당 기관과 협력할 수 있나요?',
      answer:
        '공개된 수요 협력 리스트에 해당 기업 또는 기관이 포함되어 있다면, 오픈이노베이션 방식으로 선택하여 신청서와 사업계획서를 제출하시면 됩니다.\n공개된 수요 협력 리스트에 포함되어 있지 않다면, 자율 방식으로 신청서와 사업계획서를 제출하되 해당 수요처와의 협력 형태를 명확히 기재해 주셔야 합니다.\n단, 향후 최종 선정될 경우 해당 수요처 역시 본 사업에 지속적으로 참여하고 협력할 수 있어야 합니다.',
    },
  ],
  management: [
    {
      question: '3-1. 인건비는 어떻게 책정하며, 어떻게 지급되나요?',
      answer:
        '참여 인력에 한해, 해외 우수 인재 및 국내 채용 우수 인재의 인건비는 참여율 100% 기준 1인당 월 최대 800만 원까지 편성할 수 있습니다. \n단, 인건비 편성을 위해서는 최근 1년간의 급여 내역을 확인할 수 있는 근로계약서 등 관련 자료 제출이 필요합니다. \n또한 국내 세무·노무 관련 법령을 준수해야 하며, 4대 보험, 원천세, 퇴직금 등의 항목도 함께 반영되어야 합니다.',
    },
    {
      question: '3-2. 편성 가능한 비목은 정해져 있나요?',
      answer:
        '네, 인건비, 운영비, 여비, 업무추진비, 유형자산비로 편성할 수 있습니다. \n각 비목별 세부 항목 및 사용 기준은 상이하므로, 자세한 사항은 반드시 공모안내서를 참고해 주시기 바랍니다.',
    },
    {
      question: '3-3. 사업비로 장비 구입, 해외 출장, 주거비 등을 사용할 수 있나요?',
      answer:
        '장비 구입은 가능하나, 관련 규정에 따라 적정하게 관리되어야 합니다. \n본 사업은 국내 사업화 지원을 목적으로 하므로, 해외 출장 목적의 사업비 집행은 불가합니다. \n또한 주거비 역시 사업비로 집행할 수 없으며, 해당 항목은 유입 지원금으로 별도 관리해야 합니다.',
    },
    {
      question: '3-4. 정부지원금을 전액 편성하지 않아도 되나요?',
      answer:
        '네, 가능합니다. 정부지원금은 최대 2억 원 범위 내에서 편성할 수 있으며, 신청서 내 별첨 서류에 관련 내용을 작성해 제출하시면 됩니다. \n최종 선정된 팀은 심의·운영위원회를 통해 조정된 사업비를 통보받게 되며, 협약 시 최종 사업비 편성표를 수정·제출한 후 정부지원금을 지원받게 됩니다.',
    },
    {
      question: '3-5. 정부지원금을 전액 편성하지 않더라도 유입 지원금을 받을 수 있나요?',
      answer:
        '네, 지원 가능 범위 내에서는 가능합니다. 단, 유입 지원금은 최초 신청 시 제출한 참여 인력(신청서, 동의서 등 기준)에 한해서만 지원 가능합니다.',
    },
    {
      question: '3-6. 신청 시 제출한 참여 인력을 변경할 수 있',
      answer:
        '원칙적으로는 불가능합니다. \n다만 불가항력적인 사유로 인해 참여 인력을 제외해야 하는 경우에는 해당 사유를 명확히 소명해야 하며, 전문가 회의를 거쳐 전담기관의 사전 승인을 받아야 합니다. \n한편 국내 신규 채용 등의 사유에 따른 참여 인력 추가는 가능합니다.',
    },
  ],
  selection: [
    {
      question: '4-1. 평가위원은 어떤 분들로 구성되나요?',
      answer:
        '평가위원은 접수된 사업계획서와 오픈이노베이션 과제를 바탕으로 기술 분야를 구분한 뒤, 국내외 전문가 7인 내외로 구성될 예정입니다.',
    },
    {
      question: '4-2. 대면 평가에 참석할 수 없는 경우, 발표평가는 어떻게 진행되나요?',
      answer:
        '대면 평가에 참석할 수 없는 경우, 팀 전원 불참 확인서를 기한 내 제출해야 합니다. \n이후 평가에 필요한 제반 자료를 기한 내 제출하거나 비대면 화상 평가로 대체할 수 있습니다. \n단, 기한 내 사전 확인서와 관련 자료를 모두 제출하지 않을 경우에는 서면 평가로 대체됩니다.',
    },
    {
      question: '4-3. 대면 평가 참석 시 참석비 지원이 있나요?',
      answer: '아니요, 별도의 참석비 지원은 없습니다.',
    },
    {
      question: '4-4. 대면 평가 일정은 어떻게 확정되나요?',
      answer:
        '서면평가 결과 통보 시, 대면평가 일정과 함께 오전·오후 선호도 조사를 진행할 예정입니다. \n가급적 선호 일정을 반영하여 조정할 계획이나, 조정이 어려운 경우 별도 일정이 통보될 수 있습니다.',
    },
    {
      question: '4-5. 대면 평가 일정 조정이 가능한가요?',
      answer: '아니요, 원칙적으로 일정 조정은 불가합니다.',
    },
  ],
  etc: [
    {
      question: '5-1. 참여 인력은 반드시 근로계약을 체결해야 하나요?',
      answer:
        '참여 인력은 국내에 설립된 법인 소속의 근로자로서 풀타임 근무를 원칙으로 합니다. \n다만 참여 인력의 소속 기관 정책, 세금 이슈 등 개별 사정을 고려하여 적절한 고용 형태를 협의·체결할 수 있으며, 이에 대해서는 추후 운영기관을 통한 컨설팅도 가능합니다. \n참여 인력의 급여는 월별 균등 분할 지급을 원칙으로 하며, 변칙적인 운영은 허용되지 않습니다.',
    },
    {
      question: '5-2. 과제 수행 중 해외 출국 또는 출장이 가능한가요?',
      answer:
        '해외 출국 자체는 가능합니다. \n다만, 본 사업은 국내 사업화 지원을 우선 목적으로 하므로, 국외여비는 편성할 수 없으며 해외 출장과 관련된 비용 역시 사업비로 집행할 수 없습니다.',
    },
    {
      question: '5-3. 과제 중단 시 연구비는 어떻게 정산되나요?',
      answer:
        '과제 중단 사유에 따라 사업비 환수 등의 조치가 이루어질 수 있습니다. \n해당 사항은 관련 규정에 따라 심의 절차를 거쳐 최종 결정됩니다. \n과제가 중단되는 경우에는 사업비 집행도 즉시 중단해야 합니다.',
    },
    {
      question: '과제 수행 중 다른 정부지원 과제에도 지원할 수 있나요?',
      answer:
        '네, 가능합니다. \n다만, 타 정부지원 과제의 중복 지원 가능 여부 및 세부 제한 사항은 별도로 확인해 주셔야 합니다.',
    },
  ],
}
